import React from 'react';
import { Select } from 'antd';
import type { DataTypeKey } from '../types/dashboard.types';
import { DATA_TYPE_CONFIG } from '../constants/dataTypes';

interface DataTypeSelectorProps {
  readonly value?: DataTypeKey[];
  readonly onChange: (values: DataTypeKey[]) => void;
  readonly isMobile?: boolean;
  readonly placeholder?: string;
}

const DEFAULT_PLACEHOLDER = '表示データ選択';

export const DataTypeSelector: React.FC<DataTypeSelectorProps> = ({
  value,
  onChange,
  isMobile = false,
  placeholder = DEFAULT_PLACEHOLDER,
}) => {
  return (
    <Select<DataTypeKey[]>
      mode="multiple"
      showSearch={false}
      className={isMobile ? "w-full data-type-selector" : "w-[400px] data-type-selector"}
      value={value}
      onChange={onChange}
      options={Object.entries(DATA_TYPE_CONFIG).map(([key, config]) => ({
        value: key,
        label: config.label,
      }))}
      placeholder={placeholder}
      maxTagCount="responsive"
      onSearch={() => {}}
      onInputKeyDown={(e) => e.preventDefault()}
    />
  );
};
